import { GetStateQuery, getState, graphqlCall } from '@akin-home/amplify';
import { StateVariable } from '@akin-home/state-variables';
import { JSONParseSafe } from '@akin-home/utils/json';

export interface GetStateVariablesParams {
  application_id: number;

  /** User that state variables are for */
  username: string;

  /** State variable names */
  names?: string[];
}

export interface GetStateVariableParams {
  application_id: number;

  /** User that state variables are for */
  username: string;

  /** State variable name */
  name: string;
}

export const getStateVariables = async (data: GetStateVariablesParams) => {
  return JSONParseSafe(
    (await graphqlCall<GetStateQuery>(getState, { data: JSON.stringify(data) }))
      .data.getState
  ).data as StateVariable[] | undefined;
};
